/**
 * Test IDs for QA automation.
 */
export const testIds = {
  assetFiltersModalClear: "asset-filters-modal-clear",
  assetFiltersModalCancel: "asset-filters-modal-cancel",
  assetFiltersModalApply: "asset-filters-modal-apply",
} as const;
